export const COVERAGE_DATA_REVISION_KEY = 'buckeyeCoverageDataRevision';
export const COVERAGE_DATA_CHANGED_EVENT = 'buckeye-coverage-data-changed';

export function signalCoverageDataChanged(): void {
  const revision = `${Date.now()}:${Math.random().toString(36).slice(2, 8)}`;
  try { window.localStorage.setItem(COVERAGE_DATA_REVISION_KEY, revision); } catch { /* storage can be unavailable */ }
  try { window.dispatchEvent(new CustomEvent(COVERAGE_DATA_CHANGED_EVENT, { detail: revision })); } catch { /* old browser fallback not needed */ }
}
